import React from "react";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import { useNavigate } from "react-router-dom";
import { hasPermission } from "../../auth/RequirePermission3";
import PendingActionsIcon from '@mui/icons-material/PendingActions'; // For Waiting
import PriceCheckIcon from '@mui/icons-material/PriceCheck'; // For Paid
import LocalShippingIcon from '@mui/icons-material/LocalShipping'; // For Sent
import FactCheckIcon from '@mui/icons-material/FactCheck'; // For Confirmed
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'; // For Request Quote
import HighlightOffIcon from '@mui/icons-material/HighlightOff'; // For Cancel
export default function SaleHomePage() {
  const navigate = useNavigate();

  const handleClick = (url) => {
    navigate(url);
  };

  const statusButtons = React.useMemo(
    () => [
      ...(hasPermission(["ticket_open_purchase_sale"])
        ? [
          {
            label: "เปิดบิลขาย",
            color: "bg-gray-900",
            textColor: "text-white",
            iconColor: "text-gray-900",
            bgColor: "bg-gray-100",
            icon: <RequestQuoteIcon style={{ fontSize: 40 }} />,
            url: "/sale/customers",
          },
        ]
        : []),
      {
        label: "บิลรอขาย",
        color: "bg-blue-500",
        textColor: "text-gray-800",
        iconColor: "text-blue-500",
        bgColor: "bg-blue-50",
        icon: <PendingActionsIcon style={{ fontSize: 40 }} />,
        url: "/sale/ticket?status=waiting",
      },
      {
        label: "บิลส่งแล้ว",
        color: "bg-teal-500",
        textColor: "text-gray-800",
        iconColor: "text-teal-500",
        bgColor: "bg-teal-50",
        icon: <LocalShippingIcon style={{ fontSize: 40 }} />,
        url: "/sale/ticket?status=sent",
      },
      {
        label: "บิลยืนยันการขายแล้ว",
        color: "bg-amber-500",
        textColor: "text-gray-800",
        iconColor: "text-amber-500",
        bgColor: "bg-amber-50",
        icon: <FactCheckIcon style={{ fontSize: 40 }} />,
        url: "/sale/ticket?status=confirm",
      },
      {
        label: "บิลที่รับเงินแล้ว",
        color: "bg-green-500",
        textColor: "text-gray-800",
        iconColor: "text-green-500",
        bgColor: "bg-green-50",
        icon: <PriceCheckIcon style={{ fontSize: 40 }} />,
        url: "/sale/ticket?status=payed",
      },
      {
        label: "บิลที่ถูกยกเลิก",
        color: "bg-red-500",
        textColor: "text-gray-800",
        iconColor: "text-red-500",
        bgColor: "bg-red-50",
        icon: <HighlightOffIcon style={{ fontSize: 40 }} />,
        url: "/sale/ticket?status=cancel",
      },
    ],
    []
  );

  return (
    <div className="h-[calc(100vh-64px)] bg-gray-50 flex flex-col w-full">
      <div className="w-full max-w-7xl mx-auto p-4 md:p-8">
        <AppBreadcrumbs />
      </div>

      <div className="flex-1 flex flex-col items-center justify-center w-full max-w-7xl mx-auto px-4 md:px-8 pb-4 md:pb-8">

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full">
          {statusButtons.map((item) => (
            <div
              key={item.url}
              onClick={() => handleClick(item.url)}
              className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 flex flex-col items-center justify-center cursor-pointer transition-all duration-300 hover:shadow-lg hover:-translate-y-1 group"
            >
              <div className={`w-20 h-20 rounded-2xl ${item.bgColor} ${item.iconColor} flex items-center justify-center mb-6 shadow-inner transition-transform group-hover:scale-110`}>
                {item.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-700 group-hover:text-gray-900 text-center">
                {item.label}
              </h3>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
